const MIME_TYPES = {
  gif: "image/gif",
  jpeg: "image/jpeg",
  png: "image/png",
  svg: "image/svg+xml",
} as const;
type MimeType = (typeof MIME_TYPES)[keyof typeof MIME_TYPES];

const EXTENSIONS_BY_MIME_TYPE = {
  [MIME_TYPES.gif]: ".gif",
  [MIME_TYPES.jpeg]: ".jpeg",
  [MIME_TYPES.png]: ".png",
  [MIME_TYPES.svg]: ".svg",
} as const;

export { EXTENSIONS_BY_MIME_TYPE, MIME_TYPES };
export type { MimeType };
